import Vue       from 'vue';
import VueRouter from 'vue-router';
import RoutesFr  from '@/routes/routes.fr.js';
import RoutesEn  from '@/routes/routes.en.js';

// Routing
Vue.use(VueRouter);

// Catch errors from VueRouter.push()
const originalPush       = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }

    return originalPush.call(this, location).catch((err) => {
        console.warn(err);
    });
};

// Create the router
const router = new VueRouter({
    mode:   'history',
    base:   process.env.VUE_APP_BASE_URL,
    routes: RoutesFr.concat(RoutesEn)
});

router.beforeEach((to, from, next) => {
    // Save the routes
    window.localStorage.setItem('fromRoute', from.name ?? null);
    window.localStorage.setItem('toRoute', to.name ?? null);
    window.scroll(0, 0);

    // Set Global Map like default title and add meta title if exist
    const DEFAULT_TITLE = 'Global Map';
    document.title = typeof to.meta.title !== 'undefined'
        ? `${DEFAULT_TITLE} - ${to.meta.title}`
        : DEFAULT_TITLE;

    next();
});

export default router;
